export const KeyHeader = {
  AUTHORIZATION: "Authorization",
  LANG: "x-lang",
  STOREID: "storeid".trim(),
  MERCHANTID: "merchantid".trim(),
};
